/* vue */
import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import Meta from 'vue-meta';

import FastClick from 'fastclick';

/* css */
import 'normalize.css';
import 'swiper/dist/css/swiper.css'; // eslint-disable-line import/no-extraneous-dependencies
// import 'vw-layout';

/* global */
import '@/common/components'; // components

import * as filters from '@/filters'; // filters
import Monitor from '@/common/monitor';

/* directives */
import directives from '@/directives';

import App from '@/App';

Object.keys(filters).forEach((key) => { // 全局注册 filters
  Vue.filter(key, filters[key]);
});

Object.keys(directives).forEach((key) => {
  Vue.directive(key, directives[key]);
});

Vue.use(Meta);

const isProduction = process.env.VUE_APP_PACK_MODE === 'production';

Vue.config.debug = !isProduction;
Vue.config.devtools = !isProduction;
Vue.config.productionTip = !isProduction;

// 错误监控
if (isProduction) {
  Monitor.getInstance({
    environment: process.env.VUE_APP_PACK_MODE,
  });
}

window.addEventListener('load', () => {
  FastClick.attach(document.body);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
